import React, { Component } from "react";
import $ from "jquery";
import DataTable from "datatables.net-bs4";
import { ToastContainer } from "react-toastr";
import { withRouter } from "react-router-dom";
import EntryModal from "./EntryModal";
import RejectModal from "./RejectModal";
import axios from "../utils/axios";
import momentTZ from "moment-timezone";
import { reload } from "../utils/datatable";
import {
  URL_S002,
  URL_S010,
  URL_S007,
  APPROVE_STATUS,
  SEND_STATUS,
  URL_S001,
  URL_S004,
  URL_S003,
  URL_S006,
  ROLE,
} from "../utils/constants";
import { getUserInfo } from "../utils/auth";
import {
  formatApproveStatus,
  formatApproveStatusClass,
  formatDate,
  formatSendStatus,
  formatSendStatusClass,
} from "../utils/format";

function datatable(pathname, approveStatus) {
  return $("#example2").DataTable({
    responsive: true,
    autoWidth: false,
    paging: true,
    lengthChange: true,
    searching: true,
    ordering: true,
    columns: isNotEditable(pathname, approveStatus)
      ? [
          { width: "5%" },
          { width: "20%" },
          { width: "20%" },
          { width: "10%" },
          { width: "10%" },
          { width: "10%" },
          { width: "25%" },
        ]
      : [
          { width: "5%" },
          { width: "20%" },
          { width: "20%" },
          { width: "5%" },
          { width: "5%" },
          { width: "5%" },
          { width: "20%" },
          { width: "20%" },
        ],
    footerCallback: function (row, data, start, end, display) {
      var api = this.api();

      // Remove the formatting to get integer data for summation
      var intVal = function (i) {
        return typeof i === "string"
          ? i !== "-"
            ? i * 1
            : 0
          : typeof i === "number"
          ? i
          : 0;
      };

      for (let i = 3; i < 6; i++) {
        // Total over all pages
        let total = api
          .column(i)
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Update footer
        $(api.column(i).footer()).html(total);
      }
    },
  });
}

function isNotEditable(pathname, approveStatus) {
  if (pathname === URL_S010) return true;
  if (approveStatus !== null) {
    if (pathname === URL_S007 && approveStatus === APPROVE_STATUS.rejected)
      return true;
    if (approveStatus === APPROVE_STATUS.rejected) {
      return false;
    }
    return true;
  }
  return false;
}

function isCancelable(path, sendStatus, approveStatus, role) {
  if (
    (path === URL_S002 || path === URL_S004) &&
    sendStatus === SEND_STATUS.sent &&
    approveStatus === APPROVE_STATUS.pending
  ) {
    return true;
  } else if (
    path === URL_S007 &&
    (approveStatus === APPROVE_STATUS.approved ||
      approveStatus === APPROVE_STATUS.rejected)
  ) {
    return true;
  } else if (
    path === URL_S002 &&
    role === ROLE.manager &&
    (approveStatus === APPROVE_STATUS.approved ||
      approveStatus === APPROVE_STATUS.rejected)
  ) {
    return true;
  }
  return false;
}

class S004 extends Component {
  constructor(props) {
    super(props);
    const id = this.props.match.params.id;
    this.state = {
      id,
      name: "",
      timeRecords: [],
      date: "",
      idToBeDeleted: "",
      sendStatus: "",
      approveStatus: "",
      focusLine: {
        workMinutes: 0,
        otMinutes: 0,
        nonPerformMinutes: 0,
        workstation_id: "",
        project_id: "",
        non_perform_type_id: "",
      },
      total: {
        totalWorkHour: 0,
        totalOt: 0,
      },
      lastSeq: 0,
      modalType: "add",
      empId: "",
      existCombination: [],
      isHoliday: this.props.location.state
        ? this.props.location.state.isHoliday
        : false,
    };
    $.DataTable = DataTable;
    this._handleDelete = this._handleDelete.bind(this);
    this._handleToBeDeleted = this._handleToBeDeleted.bind(this);
    this._handleChange = this._handleChange.bind(this);
  }

  container;

  _handleCreateTimesheetLine = async () => {
    try {
      let timeSheetId = this.state.id;
      if (timeSheetId == "null") {
        const info = getUserInfo();
        const date = this.props.location.state.date;
        let data;
        if (this.props.location.pathname.slice(0, 10) === URL_S002) {
          data = {
            docNbr: `${date.slice(0, 10)}_${info.empId}`,
            department_id: info.departmentId,
            employee_id: info.empId,
            workDate: date,
            sendStatus: SEND_STATUS.pending,
            createdBy: info.userId,
            updatedBy: info.userId,
          };
        } else {
          data = {
            docNbr: `${date.slice(0, 10)}_${this.state.employee_id}`,
            department_id: this.state.department_id,
            employee_id: this.state.employee_id,
            workDate: date,
            sendStatus: SEND_STATUS.pending,
            createdBy: info.userId,
            updatedBy: info.userId,
          };
        }
        const id = await axios()
          .post(`/timesheets`, data)
          .then((res) => {
            console.log(res);
            return res.data.id;
          })
          .catch((err) => {
            const msg = err.response.data.msg
            this.container.error(
              `Error when Creating Timesheet: ${msg || err.message}`
            );
          });
        this.setState({ id });
        this.setState({
          focusLine: { ...this.state.focusLine, timesheet_id: id },
        });
        timeSheetId = id;
      }
      await axios()
        .post(`/timesheetlines`, {
          ...this.state.focusLine,
          workMinutes: +this.state.focusLine.workMinutes * 60,
          otMinutes: +this.state.focusLine.otMinutes * 60,
          nonPerformMinutes: +this.state.focusLine.nonPerformMinutes * 60,
        })
        .then((res) => {
          console.log(res);
          return res.data;
        });
      this.container.success(`Created successfully`, null, {
        timeOut: 500,
      });
      reload(
        this.props.history,
        this.props.location.pathname.slice(0, 10) + `/${timeSheetId}`,
        { isHoliday: this.state.isHoliday }
      );
    } catch (err) {
      const msg = err.response.data.msg
      this.container.error(`Error when Creating: ${msg ||err.message}`);
      console.log(err);
    }
  };

  _handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  getTimesheet = async (id) => {
    try {
      if (id !== "null") {
        const response = await axios()
          .get(`/timesheets/${id}`)
          .then((res) => {
            console.log(res);
            return res.data;
          });
        let existCombination = [];
        if (response.TimesheetLines.length > 0) {
          response.TimesheetLines.sort((a, b) => (a.seq > b.seq ? 1 : -1));
          this.setState({
            lastSeq:
              response.TimesheetLines[response.TimesheetLines.length - 1].seq,
          });
          this.setState({ timeRecords: response.TimesheetLines });
          response.TimesheetLines.map((item) => {
            existCombination.push({
              workstation_id: item.workstation_id,
              project_id: item.project_id,
            });
            return true;
          });
        }
        this.setState({ name: response.Employee.fullName });
        this.setState({ empCode: response.Employee.code });
        this.setState({ sendStatus: response.sendStatus });
        this.setState({ approveStatus: response.approveStatus });
        this.setState({ date: response.workDate });
        this.setState({ department_id: response.Department.id });
        this.setState({ existCombination });
        this.setState({ employee_id: response.Employee.id });
      } else {
        this.setState({ name: this.props.location.state.name });
        this.setState({ empCode: this.props.location.state.empCode });
        this.setState({ sendStatus: null });
        this.setState({ approveStatus: null });
        this.setState({ date: this.props.location.state.date });
        this.setState({
          department_id: this.props.location.state.department_id,
        });
        this.setState({
          employee_id: this.props.location.state.employee_id,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  getTimesheetLine = async (id) => {
    try {
      const response = await axios()
        .get(`/timesheetlines/${id}`)
        .then((res) => {
          console.log(res);
          return res.data;
        });
      response.workMinutes /= 60;
      response.otMinutes /= 60;
      response.nonPerformMinutes /= 60;
      this.setState({ focusLine: response });
      this.setState({
        total: {
          totalWorkHour:
            +this.state.total.totalWorkHour -
            +this.state.focusLine.workMinutes -
            +this.state.focusLine.nonPerformMinutes,
          totalOt: +this.state.total.totalOt - +this.state.focusLine.otMinutes,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  _handleUpdateTimesheetLine = async () => {
    try {
      const token = this.props.token;
      const id = this.state.focusLine.id;
      const timeSheetId = this.state.id;
      await axios()
        .put(
          `/timesheetlines/${id}`,
          {
            ...this.state.focusLine,
            workMinutes: +this.state.focusLine.workMinutes * 60,
            otMinutes: +this.state.focusLine.otMinutes * 60,
            nonPerformMinutes: +this.state.focusLine.nonPerformMinutes * 60,
          },
          {
            headers: {
              Authorization: `jwt ${token}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          return res.data;
        });
      this.container.success(`Updated successfully`, null, {
        timeOut: 500,
      });
      reload(
        this.props.history,
        this.props.location.pathname.slice(0, 10) + `/${timeSheetId}`,
        { isHoliday: this.state.isHoliday }
      );
    } catch (err) {
      const msg = err.response.data.msg
      this.container.error(`Error when Updating: ${msg || err.message}`);
      console.log(err);
    }
  };

  _handleToBeDeleted(e) {
    e.preventDefault();
    this.setState({ idToBeDeleted: e.target.id });
  }

  async _handleDelete(e) {
    e.preventDefault();
    try {
      const id = this.state.idToBeDeleted;
      const timeSheetId = this.state.id;
      await axios()
        .delete(`/timesheetlines/${id}`)
        .then((res) => {
          console.log(res);
          return res.data;
        });
      this._handleChangeStatus();
      if (this.state.timeRecords.length === 1) {
        await axios()
          .delete(`/timesheets/${timeSheetId}`)
          .then((res) => {
            console.log("Delete timesheet sucessfully");
            return res.data;
          });
        this.container.success(`Deleted successfully`, null, {
          timeOut: 500,
        });
        reload(
          this.props.history,
          this.props.location.pathname.slice(0, 10) + `/null`,
          {
            date: this.state.date,
            department_id: this.state.department_id,
            name: this.state.name,
            empCode: this.state.empCode,
            employee_id: this.state.employee_id,
            isHoliday: this.state.isHoliday,
          }
        );
      } else {
        this.container.success(`Deleted successfully`, null, {
          timeOut: 500,
        });
        reload(
          this.props.history,
          this.props.location.pathname.slice(0, 10) + `/${timeSheetId}`,
          { isHoliday: this.state.isHoliday }
        );
      }
    } catch (err) {
      this.container.error(`Error when Deleting: ${err.message}`);
      console.log(err);
    }
  }

  async _handleApprove() {
    const timeSheetId = this.state.id;
    await axios()
      .put(`/timesheets/${timeSheetId}`, {
        approveStatus: APPROVE_STATUS.approved,
        approveDate: Date.now(),
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
  }

  async _handleSubmit() {
    const timeSheetId = this.state.id;
    await axios()
      .put(`/timesheets/${timeSheetId}`, {
        sendStatus: SEND_STATUS.sent,
        sendDate: Date.now(),
        approveStatus: APPROVE_STATUS.pending,
        approveDate: Date.now(),
        remark: null,
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
    if (getUserInfo().userRole === ROLE.manager) await this._handleApprove();
    let toPage;
    let path = this.props.location.pathname.slice(0, 10);
    if (path === URL_S002) {
      toPage = URL_S001;
    } else if (path === URL_S004) {
      toPage = URL_S003 + `/${this.state.department_id}`;
    }
    let month = momentTZ(this.state.date).tz("Asia/Bangkok").format("MM-YYYY");
    console.log(month);
    this.props.history.push({
      pathname: toPage,
      state: {
        month: month,
      },
    });
  }

  _handleChangeStatus = async () => {
    const timeSheetId = this.state.id;
    await axios()
      .put(`/timesheets/${timeSheetId}`, {
        sendStatus: SEND_STATUS.pending,
        sendDate: null,
        approveStatus: null,
        approveDate: null,
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
  };

  _handleCancelApprove = async () => {
    const timeSheetId = this.state.id;
    await axios()
      .put(`/timesheets/${timeSheetId}`, {
        approveStatus: APPROVE_STATUS.pending,
        approveDate: Date.now(),
        remark: "",
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
  };

  _handleReject = async (remark) => {
    const timeSheetId = this.state.id;
    await axios()
      .put(`/timesheets/${timeSheetId}`, {
        approveStatus: APPROVE_STATUS.rejected,
        approveDate: Date.now(),
        remark,
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
    this.props.history.push(URL_S006 + `/${this.state.department_id}`);
  };

  componentDidMount = async () => {
    const id = this.state.id;
    await this.getTimesheet(id);
    let totalWorkHour = 0;
    let totalOt = 0;
    this.state.timeRecords.map((item) => {
      totalWorkHour +=
        (+item.workMinutes || 0) / 60 + (+item.nonPerformMinutes || 0) / 60;
      totalOt += (+item.otMinutes || 0) / 60;
      return true;
    });
    this.setState({ total: { totalWorkHour, totalOt } });
    datatable(
      this.props.location.pathname.slice(0, 10),
      this.state.approveStatus
    );
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => (this.container = ref)}
          className="toast-top-right"
        />
        {/* Main content */}
        <section className="content m-2">
          <div className="row mx-0">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div
                      className="align-self-start"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => this.props.history.goBack()}
                    >
                      <i className="fas fa-arrow-alt-circle-left fa-2x" />
                    </div>
                    {this.props.location.pathname.slice(0, 10) !== URL_S002 && (
                      <>
                        <div className="input-group col-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">Employee</span>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            value={this.state.empCode + " " + this.state.name}
                            disabled
                          />
                        </div>
                      </>
                    )}
                    <div className="input-group col-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="far fa-calendar-alt" />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="date"
                        value={formatDate(this.state.date)}
                        disabled
                      />
                    </div>
                    <div className="input-group col-2">
                      <div className="input-group-prepend">
                        <span
                          className={
                            "input-group-text " +
                            formatSendStatusClass(this.state.sendStatus)
                          }
                        >
                          Send Status:
                          {formatSendStatus(this.state.sendStatus, 2)}
                        </span>
                      </div>
                    </div>
                    <div className="input-group col-3">
                      <div className="input-group-prepend">
                        <span
                          className={
                            "input-group-text " +
                            formatApproveStatusClass(this.state.approveStatus)
                          }
                        >
                          Approve Status:
                          {formatApproveStatus(this.state.approveStatus, 2)}
                        </span>
                      </div>
                    </div>
                    {this.props.location.pathname.slice(0, 10) === URL_S007 &&
                    this.state.approveStatus === APPROVE_STATUS.pending ? (
                      <>
                        <div className="col align-self-end">
                          <button
                            onClick={(e) => {
                              this._handleApprove(e);
                              this.props.history.push(
                                URL_S006 + `/${this.state.department_id}`
                              );
                            }}
                            className="btn btn-success float-right ml-3"
                          >
                            Approve
                          </button>
                          <button
                            data-toggle="modal"
                            data-target="#modal-reject"
                            className="btn btn-danger float-right"
                          >
                            Reject
                          </button>
                        </div>
                      </>
                    ) : isCancelable(
                        this.props.location.pathname.slice(0, 10),
                        this.state.sendStatus,
                        this.state.approveStatus,
                        getUserInfo().userRole
                      ) ? (
                      <div className="col align-self-end">
                        <button
                          onClick={(e) => {
                            if (
                              this.props.location.pathname.slice(0, 10) ===
                              URL_S007
                            ) {
                              this._handleCancelApprove();
                            } else {
                              //path S002 or S004
                              if (
                                this.props.location.pathname.slice(0, 10) ===
                                  URL_S002 &&
                                getUserInfo().userRole === ROLE.manager
                              ) {
                                this._handleCancelApprove();
                              }
                              this._handleChangeStatus();
                            }
                            const timeSheetId = this.state.id;
                            reload(
                              this.props.history,
                              this.props.location.pathname.slice(0, 10) +
                                `/${timeSheetId}`,
                              { isHoliday: this.state.isHoliday }
                            );
                          }}
                          className="btn btn-info float-right"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : isNotEditable(
                        this.props.location.pathname.slice(0, 10),
                        this.state.approveStatus
                      ) || (this.state.total.totalWorkHour < 8 && !this.state.isHoliday) ? null : (
                      <div className="col align-self-end">
                        <button
                          onClick={(e) => {
                            this._handleSubmit();
                          }}
                          className="btn btn-success float-right"
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <table
                    id="example2"
                    className="table table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Work Station</th>
                        <th>Project</th>
                        <th>Work Hour</th>
                        <th>Over Time</th>
                        <th>NP Hour</th>
                        <th>NP Type</th>
                        {isNotEditable(
                          this.props.location.pathname.slice(0, 10),
                          this.state.approveStatus
                        ) ? null : (
                          <th>
                            <button
                              data-toggle="modal"
                              data-target="#modal-add"
                              className="btn btn-sm btn-info"
                              onClick={() => {
                                this.setState({ modalType: "add" });
                                this.setState({
                                  focusLine: {
                                    seq: this.state.lastSeq + 1,
                                    timesheet_id: this.state.id,
                                    workMinutes: 0,
                                    otMinutes: 0,
                                    nonPerformMinutes: 0,
                                    workstation_id: "",
                                    project_id: "",
                                    non_perform_type_id: "",
                                  },
                                });
                              }}
                            >
                              <i className="fas fa-plus"></i>
                            </button>
                          </th>
                        )}
                      </tr>
                    </thead>

                    {this.state.timeRecords.length > 0 ? (
                      <>
                        <tbody>
                          {this.state.timeRecords.map((item, index) => {
                            return (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>
                                  {item.Workstation
                                    ? item.Workstation.name
                                    : "-"}
                                </td>
                                <td>
                                  {item.Project ? item.Project.name : "-"}
                                </td>
                                <td>{+item.workMinutes / 60 || "-"} </td>
                                <td>{+item.otMinutes / 60 || "-"}</td>
                                <td>{+item.nonPerformMinutes / 60 || "-"}</td>
                                <td>
                                  {item.NonPerformType
                                    ? item.NonPerformType.name
                                    : "-"}
                                </td>
                                {isNotEditable(
                                  this.props.location.pathname.slice(0, 10),
                                  this.state.approveStatus
                                ) ? null : (
                                  <td>
                                    <button
                                      data-toggle="modal"
                                      data-target="#modal-add"
                                      className="btn btn-sm btn-primary mr-3"
                                      onClick={() => {
                                        this.setState({ modalType: "edit" });
                                        this.getTimesheetLine(item.id);
                                      }}
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                      id={item.id}
                                      data-toggle="modal"
                                      data-target="#modal-danger"
                                      className="btn btn-sm btn-danger"
                                      onClick={this._handleToBeDeleted}
                                    >
                                      <i
                                        id={item.id}
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="3" style={{ textAlign: "right" }}>
                              Total:
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            {isNotEditable(
                              this.props.location.pathname.slice(0, 10),
                              this.state.approveStatus
                            ) ? null : (
                              <th></th>
                            )}
                          </tr>
                        </tfoot>
                      </>
                    ) : null}
                  </table>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </section>

        {/* Delete Modal */}
        <div className="modal fade" id="modal-danger">
          <div className="modal-dialog">
            <div className="modal-content bg-danger">
              <div className="modal-header">
                <h4 className="modal-title">Caution!!</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you would like to delete this item?</p>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline-light"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-outline-light"
                  onClick={this._handleDelete}
                  data-dismiss="modal"
                >
                  Delete
                </button>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
        {/* /.modal */}

        {/* add modal */}
        <div
          style={{ justifyContent: "center" }}
          className="modal fade"
          id="modal-add"
        >
          <EntryModal
            id={this.state.modalId}
            modalType={this.state.modalType}
            isHoliday={this.state.isHoliday}
            workDate={this.state.date}
            info={this.state.focusLine}
            total={this.state.total}
            existCombination={this.state.existCombination}
            empName={this.state.name}
            onChange={(object) => {
              this.setState({
                focusLine: { ...this.state.focusLine, ...object },
              });
            }}
            submitTimesheetLine={() => {
              if (this.state.modalType === "edit") {
                this._handleUpdateTimesheetLine();
              } else {
                this._handleCreateTimesheetLine();
              }
              if (this.state.approveStatus === APPROVE_STATUS.rejected) {
                this._handleChangeStatus();
              }
            }}
          />
        </div>

        {/* Reject Modal */}
        <div
          style={{ justifyContent: "center" }}
          className="modal fade"
          id="modal-reject"
        >
          <RejectModal
            reject={(remark) => {
              console.log("rejecting");
              this._handleReject(remark);
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(S004);
